import React from 'react';
import { connect } from 'react-redux';
import CenterPanel from './centerPanel';
import CenterPanelReadOnly from './centerPanelReadOnly';
import RightPanelTop from './rightPanelTop';
import RightPanelBottom from './rightPanelBottom';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';

export default function BeforeCallImportantInfoWaitingArea(props) {
  let rightPanel = {};
  let centerPanel = {};
  let title = undefined;
  let subtitle = undefined;
  let trimmedGroup = {};
  let orgName = props.waitingArea ? props.waitingArea.organisationName : '';
  var updatingWaitingAreaName = (props.waitingArea ? props.waitingArea.name : '') + ' (' + orgName + ')';
  rightPanel = (
    <RightPanelTop
      waitingArea={props.waitingArea}
      beforeCallsImportantInfoForm={props.beforeCallsImportantInfoForm}
      updateOrView={props.updateOrView}
    />
  );
  centerPanel =
    props.updateOrView == 'update' ? (
      <CenterPanel beforeCallsImportantInfoForm={props.beforeCallsImportantInfoForm} waitingArea={props.waitingArea} />
    ) : (
      <CenterPanelReadOnly
        beforeCallsImportantInfoForm={props.beforeCallsImportantInfoForm}
        waitingArea={props.waitingArea}
      />
    );
  title = `${APP.LANGUAGE.WaitingAreaBeforeCallsImportantInfo.TitleUpdateAndView} ${APP.LANGUAGE.WaitingAreaBeforeCallsImportantInfo.TitleBracketPart}`;
  subtitle = updatingWaitingAreaName;

  return (
    <Modal show={props.showBeforeCallsImportantInfoModal} hideWhenClickAway={false}>
      <PopupHeader
        helpLink={APP.EXTERNAL_LINKS.ViewOneWaitingArea.HelpBeforeCallsPleaseRead}
        title={title}
        subtitle={subtitle}
      />
      <div className="content before-calls-important-info-modal">
        <div
          className={
            props.updateOrView == 'update'
              ? 'main-ui-container before-calls-important-info-modal'
              : 'main-ui-container before-calls-important-info-modal-read-only'
          }
        >
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">{rightPanel}</div>
              <RightPanelBottom updateOrView={props.updateOrView} />
            </div>
            {centerPanel}
            <div className="bottom-rail-with-left-and-right-content mrtxl">
              {rightPanel}
              <RightPanelBottom updateOrView={props.updateOrView} />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
